import useBaseIndex from "../../base/hooks/useBaseIndex";
import { PaymentReportResponseSchema } from "../response/PaymentReportResponse";

const API_VERSION = "v3";

interface Props {
    filters?: { [key: string]: any };
    [key: string]: any;
}

const usePaymentReport = (query: Props) =>
    useBaseIndex({
        ...query,
        queryKey: "payment-report" + JSON.stringify(query),
        endpoint: `${API_VERSION}/payment-report`,
        schema: PaymentReportResponseSchema, // Assuming PaymentResponseSchema is imported from the correct path
    });

export default usePaymentReport;